module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Preface#fm-1"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Introduction#fm-2"
    }
  }, [_c('em', [_vm._v("Whimsical Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Part01#pt-1"
    }
  }, [_c('strong', [_vm._v("PART ONE:")]), _vm._v(" "), _c('strong', [_vm._v("PORTRAITS OF THE “LUTHERAN” PAUL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#ch-1"
    }
  }, [_c('strong', [_vm._v("1. Augustine")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-1"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. Creation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-2"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. The Fall")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-3"
    }
  }, [_vm._v("iii. Redemption")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-iv"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-4"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "2pt"
    }
  }, [_vm._v("iv. The Place of the Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-v"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-5"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "5pt"
    }
  }, [_vm._v("v. Human Dependence on Grace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-vi"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-6"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "2pt"
    }
  }, [_vm._v("vi. Summary")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ch-2"
    }
  }, [_c('strong', [_vm._v("2. Martin Luther")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3. John Calvin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. Divine Providence and Human Responsibility")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. Adam")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-iv"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "2pt"
    }
  }, [_vm._v("iv. Abraham and Moses")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("v. The Life of the Redeemed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("vi. Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4. John Wesley")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. Of Human Nature and the Covenant of Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. The Covenant of Grace and the Path to Faith")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. The New Birth and the Path to Sanctification")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-iv"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "2pt"
    }
  }, [_vm._v("iv. The Law and the Spirit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-v"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "5pt"
    }
  }, [_vm._v("v. Providence and the “Divine Decrees”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-vi"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "2pt"
    }
  }, [_vm._v("vi. Summary")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5. A Portrait of the “Lutheran” Paul")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART TWO:")]), _vm._v(" "), _c('strong', [_vm._v("TWENTIETH-CENTURY RESPONSES TO THE “LUTHERAN” PAUL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6. Paul’s “Polemical Doctrine”: Wrede and Schweitzer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. William Wrede")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. Albert Schweitzer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7. The Faith of Paul’s Fathers: Montefiore, Schoeps, and Sanders")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. Claude G. Montefiore")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. Hans Joachim Schoeps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. E. P. Sanders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8. Paul’s Robust Conscience: Kümmel and Stendahl")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. W. G. Kümmel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. Krister Stendahl")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9. The “Righteousness of the Law”: Bultmann, Wilckens, and Sanders")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter09#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. Rudolf Bultmann")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter09#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. Ulrich Wilckens")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter09#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. E. P. Sanders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/019_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10. The “Hobgoblin” of Consistency: Drane, Hübner, and Räisänen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. John W. Drane")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. Hans Hübner")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. Heikki Räisänen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("11. Saint Paul against the Lutherans: Wright, Dunn, and Donaldson")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. N. T. Wright")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. James D. G. Dunn")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. Terence Donaldson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("12. “Lutheran” Responses")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter12#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. C. E. B. Cranfield")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter12#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. Thomas Schreiner and Andrew Das")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter12#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. Frank Thielman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-iv"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter12#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "2pt"
    }
  }, [_vm._v("iv. Mark Seifrid")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("13. Other Perspectives")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter13#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. Paul’s Anthropology: Timo Laato")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter13#sec-40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. Paul’s Rhetoric: Lauri Thurén and Jean-Noël Aletti")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter13#sec-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. Paul’s Apocalyptic Worldview: J. Louis Martyn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-iv"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter13#sec-42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "2pt"
    }
  }, [_vm._v("iv. Paul’s Theology of the Cross: Jürgen Becker")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("14. The Quotable Anti-“Lutheran” Paul")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter14#sec-43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. Judaism Preaches Grace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter14#sec-44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. What Paul Finds Wrong with Judaism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter14#sec-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. What “Justification by Faith” is For, and What “Not by Works” is Against")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Part03#pt-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART THREE:")]), _vm._v(" "), _c('strong', [_vm._v("THE HISTORICAL AND THE “LUTHERAN” PAUL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("15. Matters of Definition, 1: “Righteousness” in Paul")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#sec-46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. Terminology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#sec-47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. Ordinary Dikaiosness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/025_Chapter15#sec-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. Extraordinary Dikaiosness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-iv"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#sec-49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "2pt"
    }
  }, [_vm._v("iv. Divine Dikaiosness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-v"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#sec-50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "5pt"
    }
  }, [_vm._v("v. Dikaiosness and “the Covenant”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("16. Matters of Definition, 2: The “Law” in Paul")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec-51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. The Meaning of “Law”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec-52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. The Law and “Works”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. The Law and Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-iv"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec-54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "2pt"
    }
  }, [_vm._v("iv. The Law and Legalism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-v"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec-55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "5pt"
    }
  }, [_vm._v("v. The Law and Torah")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter17#ch-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("17. Matters of Definition, 3: Grace in Sanders’s Judaism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter18#ch-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("18. “Justification by Faith” in Paul’s Thought: The Evidence in Review")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-i"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter18#sec-56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "8pt"
    }
  }, [_vm._v("i. 1 Thessalonians")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-ii"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter18#sec-57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "4pt"
    }
  }, [_vm._v("ii. 1 and 2 Corinthians")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter18#sec-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. Galatians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-iv"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter18#sec-59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "2pt"
    }
  }, [_vm._v("iv. Romans")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-v"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter18#sec-60",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "5pt"
    }
  }, [_vm._v("v. Philippians")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-vi"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter18#sec-61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "2pt"
    }
  }, [_vm._v("vi. Ephesians, the Pastorals—and James?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter19#ch-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("19. The Law in God’s Scheme")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter20#ch-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("20. Grace Abounding to Sinners or Erasing Ethnic Boundaries?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Bibliography#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c8f4adb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0